import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const SkincareSliderSection = ({ lang, translations, images, link }) => {
  const t = translations[lang];

  return (
    <div className="slider-section" dir={lang === "ar" ? "rtl" : "ltr"}>
      <div className="slider-content-skincare">
        <div className="slider-left">
          <Swiper
            spaceBetween={0}
            slidesPerView={2}
            loop={true}
            modules={[Navigation]}
          >
            {images.map((img, index) => (
              <SwiperSlide>
                <img src={img} alt={`Skincare Set ${index + 1}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="slider-right">
          <h2>{t.title}</h2>
          <p>{t.description}</p>
          {t.description1 ? <p>{t.description1}</p> : ""}
          {t.description2 ? <p>{t.description2}</p> : ""}
          {/* {t.button ? (
            <button
              className="order-btn-skincare"
              onClick={() => navigate(link)}
            >
              {t.button}
            </button>
          ) : (
            ""
          )} */}
        </div>
      </div>
    </div>
  );
};

export default SkincareSliderSection;
